import * as React from 'react';

import Icon from 'components/icon';
import InputField from 'components/Form/InputField';

interface Step1ProjectProps {
  isReadOnly?: boolean;
}

/**
 * Step 1 of 4 - the user names their project so we can persist it
 * (and they can resume later via the project link). Surrounding chrome
 * (eyebrow, step indicator, body copy) lives in `WizardLayout`.
 */
export const Step1Project: React.VFC<Step1ProjectProps> = ({ isReadOnly }) => {
  return (
    <fieldset disabled={isReadOnly} style={{ border: 'none', padding: 0, margin: 0 }}>
      <div className="o-row o-row--small-gutters">
        <div className="o-col-12@sm u-mb-spacer-base-small">
          <InputField
            name="project_name"
            label="Project Name"
            elStyle="fill"
            large
            icon={<Icon name="item" className="o-svg-icon" />}
            placeholder="e.g. North Tower - Floor 12 Locker Room"
          />
        </div>
      </div>
    </fieldset>
  );
};

export default Step1Project;
